module.exports = __webpack_public_path__ + "static/year_month_rows-2c63c13013023272d13829dd142b8172.png";